import { TranslateService } from './../../shared/translate';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationRouteURL, WeGoConfig, RoleLevel } from './../../shared/config';
@Component({
  selector: 'wego-navbar',
  template: require('../views/navbar.component.html'),
  styles: [
    `
    .main-header .logo,
    .main-header .logo:hover{
      background-color: #fff;
      border-bottom: 1px solid #E2E2E2;
      padding: 0px;
    }
    .logo-lg{
      padding-left: 5px;
    }
    `
  ]
})

export class NavbarComponent implements OnInit, OnDestroy {
  @Output() toggleMenu = new EventEmitter();
  firstName: string;
  middleName: string;
  lastName: string;
  currentRole: string;
  highestEntityLevelRole : string;
  personHashId: string;
  urlPersonUpdate: string;
  language: string;
  languageLbl: string;
  intervalHandler: any;
  private unreadNotification = 0;
  roleLevel = RoleLevel;
  
  constructor(private router: Router
    , private authService: AuthService
    , private translateService: TranslateService) { }

  ngOnInit() {
    this.GetUserSetting();
    this.urlPersonUpdate = this.authService.GetURL(ApplicationRouteURL.URL_USER_PROFILE_UPDATE);
    
    this.intervalHandler = setInterval(() => this.GetNotificationCount(), (WeGoConfig.NOTIFICATION_REFRESH_INTERVAL_SEC * 1000));
    this.GetNotificationCount();
    
    switch(this.translateService.currentLang) {
      case "en": {
        this.language = "En";
        this.languageLbl = "EN";
        break;
      }
      case "nl": {
        this.language = "Du";
        this.languageLbl = "NL";
        break;
      }
      case "de": {
        this.language = "De";
        this.languageLbl = "DE";
        break;
      }
      case "fr": {
        this.language = "Fr";
        this.languageLbl = "FR";
        break;
      }
      case "pl": {
        this.language = "Pl";
        this.languageLbl = "PL";
        break;
      }
      case "pt": {
        this.language = "Pt";
        this.languageLbl = "PT";
        break;
      }      
      default : {
        this.language = "Es";
        this.languageLbl = "Lbl";
        break;
      }
    }

  }

  Logout() {
    this.SignOut();
    this.authService.Logout();
    this.router.navigate(['/']);
  }

  GetUserSetting() {
    let userSetting = this.authService.GetUserSetting();
    if (userSetting) {
      this.firstName = userSetting.firstName;
      this.lastName = userSetting.lastName;
      this.middleName = userSetting.middleName;
      this.highestEntityLevelRole = userSetting.highestEntityLevelRole;
    }
    let userRole = this.authService.GetCurrentRole();
    if (userRole) {
      this.currentRole = userRole;
    }

    let personHashId = this.authService.GetPersonHashId();
    if (personHashId) {
      this.personHashId = personHashId;
    }
  }

  Profile() {
    this.router.navigate(['/']);
  }

  private ToggleMenuLocal($event: any) {
    this.toggleMenu.emit($event);
  }

  SignOut() {
    this.authService.Signout()
      .subscribe(
      res => {
        console.log(res);
      },
      error => {
        console.log(error);
      });
  }

  GetNotificationCount() {
    this.authService.GetNotificationCount()
      .subscribe(
      res => {
        this.unreadNotification = res.data;
        console.log(this.unreadNotification);
      },
      error => {
        console.log(error);
      });
  }

  ResetNotificationCount() {
    this.authService.ResetNotificationCount()
      .subscribe(
      res => {
        if (res.data) {
          this.unreadNotification = 0;
        }
        let url = this.authService.GetURL(ApplicationRouteURL.URL_INBOX_PAGE);
        this.router.navigate([url, { v: Date.now() }]);
        //console.log(this.unreadNotification);
      },
      error => {
        console.log(error);
      });
  }

  ChangeCurrentLanguage(language: string) {
    if (language != 'de') {
      this.authService.UpdateUserLanguagePreference(language)
          .subscribe(
        res => {
        },
        error => {
          this.authService.HandleErrorStatusCode(error);
        },
        () => {
          localStorage.setItem("language", language);
          //this.translateService.setDetectedLang();

          switch(this.translateService.currentLang) {
            case "en": {
              this.language = "En";
              this.languageLbl = "EN";
              break;
            }
            case "nl": {
              this.language = "Du";
              this.languageLbl = "NL";
              break;
            }
            case "de": {
              this.language = "De";
              this.languageLbl = "DE";
              break;
            }
            case "fr": {
              this.language = "Fr";
              this.languageLbl = "FR";
              break;
            }
            case "pl": {
              this.language = "Pl";
              this.languageLbl = "PL";
              break;
            }
            case "pt": {
              this.language = "Pt";
              this.languageLbl = "PT";
              break;
            }
            default : {
              this.language = "Es";
              this.languageLbl = "Lbl";
              break;
            }
          }

          location.reload(true);
        });
    } else {
      localStorage.setItem("language", language);
      //this.translateService.setDetectedLang();
      this.language = "Es";
      this.languageLbl = "Lbl";
      location.reload(true);
    }
    //this.router.navigate(['/']);
  }

  ngOnDestroy() {
    if (this.intervalHandler) {
      clearInterval(this.intervalHandler);
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-template/components/navbar.component.ts